import {
  Component, Inject, Input, Renderer2, ViewChild, ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { parseDate } from '@progress/kendo-angular-intl';
import { Observable } from 'rxjs';
import { TransferRequestDetail } from '~/front-models/transferRequestGrid';
import { ComponentBase } from '~/infrastructure/component-base';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldSummary } from '~/models/modules/gridField';
import { StockItemSummary } from '~/models/modules/item';
import { TransferRequestSummary } from '~/models/modules/transferRequest';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { AccountsService } from '~/services/administration.ts/accounts';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';
import { FormatService } from '~/services/administration.ts/format';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { TransferRequestsService } from '~/services/modules/stocks/transferRequests';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { FormatTypes } from '~/shared/enums/FormatTypes';

@Component({
    selector: 'app-stocks-transfer-requests-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksTransferRequestsUpsertComponent extends ComponentBase {
    _theme: string;
    _isNew: boolean;
    _form: FormGroup;
    _active: boolean;
    _fromSites: any[];
    _toSites: any[];
    _showStocksGrid: boolean;
    _selectedStocks: any[] = [];
    _selectedStocksKeys: any[] = [];
    _selectedFromAccounts: any;
    _selectedToAccounts: any;
    _selectedFromSites: any;
    _selectedToSites: any;
    _gridColumns: GridFieldSummary[];
    _transferQuantity: any[] = [];
    _scheduledDate: string;
    _invalidForm: boolean;
    _stockItemsGridColumns: GridFieldSummary[];
    _stockGridData: TransferRequestDetail[] = [];
    _items: any[];
    _itemsFiltered: any[];
    _selectedCallback = (args: { dataItem: any; }) => args.dataItem;
    _isProcessed: boolean = false;
    _costFormat: string;

    @ViewChild('kendo_combo_fromaccounts') kendoComboFromAccounts: AccountsDropdownComponent;
    @ViewChild('kendo_combo_toaccounts') kendoComboToAccounts: AccountsDropdownComponent;
    @ViewChild('kendo_combo_fromsites') kendoComboFromSites: ComboBoxComponent;
    @ViewChild('kendo_combo_tosites') kendoComboToSites: ComboBoxComponent;
    @ViewChild('quantity_input') quantityInput: NumericTextBoxComponent;
    @ViewChild('kendo_combo_items') kendoComboItems: ComboBoxComponent;
    _selectedStockItem = new FormControl();
    _quantity = new FormControl();
    _defaultQuantity = new FormControl();
    _model: any;
    data: any;
    @Input() model: TransferRequestSummary;

     comboBoxpagingationParams = {
            currentItem: "0",
            totalbyPage: 20,
            search:''
        };
  prevoiusValue:string;
  beginScroll:boolean;
  clearTimeout:any;
  previousValue:string;
  isOpened:boolean = false;
  timeOut: any;
  isLoading :boolean = false;
  _itemFilter: string;
  autoCorrect:boolean = true;
  _showStockItemFileNotes:boolean = false;
  _stockItemNotesModel:StockItemSummary;
  costPriceFormatType: FormatTypes= FormatTypes.CostandPriceFormat;
quantityFormatType: FormatTypes= FormatTypes.QuantityFormat;
    constructor(
        private _layoutManager: LayoutManagerService,
        // @Inject(PORTAL_DATA) public data: any,
        private _themeManager: ThemeManagerService,
        private _accountsService: AccountsService,
        private _stockItemsService: StockItemsService,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _gridFields: GridFieldsService,
        private _transferRequestsService: TransferRequestsService,
        private _fb: FormBuilder,
        private _formatService : FormatService,
        private _layoutComponent: LayoutComponent,
        private _sharedService: SharedService,
        private _renderer2:Renderer2
    ) {
      super();
        this.data = this._sharedService.model;
        if (this.data) {
            this._model = this.data.model;
            this._isNew = this.data.isNew;
            this._active = true;
        }
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });
        this._layoutManager.applyOverly();

        this._gridFields
            .getGridFieldsByPage('stockItems')
            
            .subscribe((data: any) => {
                this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
            });

        this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
            this._stockItemsGridColumns = gridColumns;
            // if (this._showStocksGrid == true) {
            //     this._showStocksGrid = false;
            //     setTimeout(() => {
            //         this._showStocksGrid = true;
            //     });
            // }
        }));
    }
    ngOnDestroy() {
        this._layoutManager.removeOverlay();
    }

    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }
    _onCancel() {
        this._closeForm();
    }

    _closeForm() {
        var closeComponent = {
          component : 'transferRequests',
          isClosed : true
        }
        this._active = false;
        this._gridLayoutManagerService.setGridDataSubjects('transferRequests');
        this.ngOnDestroy();
        this._sharedService.closeDialog.emit(closeComponent);
        this._sharedService.model = {};
    }

    ngOnInit() {
        if (this._model == null || this._model.id == null) {
            setTimeout(() => {
                if (this.kendoComboFromAccounts) {
                    this.kendoComboFromAccounts.toggle(true);
                    this.kendoComboFromAccounts.focus();
                }
            });
        }

        this._form = this._fb.group({
            accountfromid: [this._model && this._model.accountFrom, Validators.required],
            accounttoid: [this._model && this._model.accountTo, Validators.required],
            sitefromid: [this._model && this._model.siteFrom, Validators.required],
            sitetoid: [this._model && this._model.siteTo, Validators.required],
            scheduledate: [(this._model && this._model.scheduleDate) ? parseDate(this._model.scheduleDate) : null],
            notes: [(this._model && this._model.notes) ? this._model.notes : null],
        });
        if (this._model != null && this._model.accountFrom != null && this._model.accountTo != null && this._model.siteFrom != null && this._model.siteTo != null) {
            this._LoadFromSitesDD(this._model.accountFrom.id, true);
            this._LoadToSitesDD(this._model.accountTo.id, true);
            this._loadTransferItems();
            //this._loadItemsDD(this._model.siteFrom.id, true);
        }


        this._initForm();

        this._selectedStockItem.valueChanges.subscribe((x) => {
            if (x) {
                let gridItem = this._stockGridData.find(r => r.stockNumber === x.number);
                if (!gridItem) {
                    if (this._defaultQuantity.value) {
                        setTimeout(() => {
                            this.fillGrid();
                        });
                    }
                }
            } else {
                if (!this._defaultQuantity.value) {
                    this._quantity.setValue(null);
                }
            }
        });
    }

    _LoadFromSitesDD(id: any, firstEdit: any = false) {
        this._accountsService.getSitesListByAccount(id)
            .subscribe((data: any) => {
                this._fromSites = data.filter((x: { name: string }) => x.name != 'All Sites');

                if (!firstEdit) {
                    setTimeout(() => {
                        this.kendoComboFromSites.toggle(true);
                        this.kendoComboFromSites.focus();
                    });
                }
            });
    }

    _LoadToSitesDD(id: any, firstEdit: any = false) {
        this._accountsService.getSitesListByAccount(id)
            .subscribe((data: any) => {
                this._toSites = data.filter((x: { name: string }) => x.name != 'All Sites');

                if (!firstEdit) {
                    setTimeout(() => {
                        this.kendoComboToSites.toggle(true);
                        this.kendoComboToSites.focus();
                    });
                }
            });
    }

    _fromAccountsSelectionChanged(model: any): void {
        this._selectedStocksKeys = [];
        this._fromSites = [];
        this._transferQuantity = [];
        this._stockGridData = [];
        this._selectedFromSites = null;
        this._LoadFromSitesDD(model.id);
    }

    _toAccountsSelectionChanged(model: any): void {
        this._toSites = [];
        this._selectedToSites = null;
        this._LoadToSitesDD(model.id);
    }

    _fromSitesSelectionChanged(model: any): void {
        this._selectedStocksKeys = [];
        this._transferQuantity = [];
        this._stockGridData = [];

        setTimeout(() => {
            this.kendoComboToAccounts.toggle(true);
            this.kendoComboToAccounts.focus();
        });
    }

    _toSitesSelectionChanged(model: any): void {
        var fromsite =  this._form.get('sitefromid').value;

         if (fromsite != null && model != null) {
            this._loadTransferItems();
             //this._loadItemsDD(fromsite.id);
          }

        if (model != null) {
            setTimeout(() => {
                this.kendoComboItems.toggle(true);
                this.kendoComboItems.focus();
            });
        }
    }

    _selectStocksHandler(): void {
        if (!this._selectedFromAccounts) {
            this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'Please select the from account',
                withoutConfirm: true
            });
        } else if (!this._selectedFromSites) {
            this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'Please select the from site',
                withoutConfirm: true
            });
        } else {
            this._showStocksGrid = true;
        }
    }

    _returnSelectedStocksHandler(e: any[]): void {
        this._showStocksGrid = false;
        this._selectedStocks.forEach((item: StockItemSummary) => {
            let gridItem = this._stockGridData.find(r => r.stockNumber === item.number);
            if (!gridItem) {
                this._stockGridData.push({
                    stockId: item.id,
                    stockNumber: item.number,
                    description: item.description,
                    transferQuantity: this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0,
                    uom: item.receiveUnitOfMeasure.code,
                    unitCost: (item.costInfo && item.costInfo.cost) ? item.costInfo.cost : 0,
                    extendedCost: (item.costInfo && item.costInfo.cost) ? (item.costInfo.cost * (this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0)) : 0,
                    isTaxable: (item.costInfo != null && item.costInfo.isTaxable != null) ? item.costInfo.isTaxable : false,
                });
            }
        });
    }

    _removeHandler({ sender, dataItem }: any) {
        this._stockGridData = this._stockGridData.filter((x: any) => x.stockNumber != dataItem.stockNumber);
    }

    _onTransferQuantityChange(e: any, item: TransferRequestDetail) {
        item.transferQuantity = e;
        item.extendedCost = e * item.unitCost;
    }

    _closeStocksWindow(): void {
        this._showStocksGrid = false;
    }

    _onStockRowSelectionChanges(e: any[]) {
        this._selectedStocks = [];
        e.forEach((item) => {
            this._selectedStocks.push(item);
        });
    }

    _getStockItems = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
        if (model != null && model.filter != null && this._form.get('sitefromid').value != null && this._form.get('sitefromid').value.id != null) {
            model.SiteId = this._form.get('sitefromid').value.id;
            return this._stockItemsService.getStockItems(params, model);
        }
    }
    _loadTransferItems(){
      let fromAccount = this._form.get('accountfromid').value;
      let toAccount = this._form.get('accounttoid').value;
      let fromSite = this._form.get('sitefromid').value;
      let toSite = this._form.get('sitetoid').value;
      let requestModel:any = {};
      requestModel.fromAccount = fromAccount.id;
      requestModel.toAccount = toAccount.id;
      requestModel.fromSite = fromSite.id;
      requestModel.toSite = toSite.id;
    this.previousValue = this.comboBoxpagingationParams.search;
    return this._stockItemsService.getStockItemsListingFortransfer(requestModel,this.comboBoxpagingationParams)
      .subscribe((data: any) => {
        //this._itemsFiltered = data.body;
       if (this.comboBoxpagingationParams.search == '') {
                if (!this.beginScroll) {
                     this._itemsFiltered = data.body;
                }else{
                    this._itemsFiltered = [...this._itemsFiltered,...data.body];
                }
            } else {
                if (!this.beginScroll) {
                 this._itemsFiltered = data.body;
                } else {
                    this._itemsFiltered = [...this._itemsFiltered,...data.body];
                }
            }
      });
    }
    _loadItemsDD(siteId: number, firstEdit: any = false) {
    this.previousValue = this.comboBoxpagingationParams.search;
    return this._stockItemsService.getStockItemsListingBySiteWithPoDetails(siteId,this.comboBoxpagingationParams)
      .subscribe((data: any) => {
        if (this.comboBoxpagingationParams.search == '') {
                if (!this.beginScroll) {
                     this._itemsFiltered = data.body;
                }else{
                    this._itemsFiltered = [...this._itemsFiltered,...data.body];
                }
            } else {
                if (!this.beginScroll) {
                 this._itemsFiltered = data.body;
                } else {
                    this._itemsFiltered = [...this._itemsFiltered,...data.body];
                }
            }
            // if (firstEdit) {
            //         setTimeout(() => {
            //             this.kendoComboItems.toggle(true);
            //             this.kendoComboItems.focus();
            //         });
            //     }
      });


    }

   _handleItemsFilter(value: any) {
       if (this.timeOut) clearTimeout(this.timeOut);
        var doneTypingInterval = 1000;  //time in ms, 5 seconds for example
        this._itemFilter = value;
        this.timeOut = setTimeout(() => {
        this.comboBoxpagingationParams.search = this._itemFilter;
        this.comboBoxpagingationParams.currentItem = "0";
       var site =  this._form.get('sitefromid').value;
       this._loadTransferItems();
        //this._loadItemsDD(site.id);
        }, doneTypingInterval);

    // this._itemsFiltered = this._items.filter(
    //   (s) => s.number.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
    //     s.description?.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
    //     s.itemType.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

    _handleItemsChange(value: any) {
        if (value != null) {
            setTimeout(() => {
                this.quantityInput.focus();
            });
        }
    }

    _quantitySubmited() {
        if (this._selectedStockItem.value) {
            this.fillGrid();
        } else {
            setTimeout(() => {
                this.kendoComboItems.toggle(true);
                this.kendoComboItems.focus();
            });
        }
    }

    private fillGrid() {
        let item = this._selectedStockItem.value;
        let gridItem = this._stockGridData.find(x => x.stockNumber === item.number);
        this._stockItemsService.getStockItem(item.id)
            
            .subscribe((data) => {
                if (gridItem) {
                    this._stockGridData = this._stockGridData.filter((x: any) => x.stockNumber != gridItem.stockNumber);
                    this._layoutComponent.openPopup({
                        title: 'Validation',
                        message: 'Duplicate item is found. The old entry has been removed.',
                        returnAfterOkCloseClick: true,
                        withoutConfirm: true
                    });
                }

                this._stockGridData.push({
                    stockId: data.id,
                    stockNumber: data.number,
                    description: data.description,
                    transferQuantity: this._quantity.value ? +this._quantity.value : 0,
                    uom: data.receiveUnitOfMeasure.code,
                    unitCost: (item.costInfo && item.costInfo.cost) ? item.costInfo.cost : 0,
                    extendedCost: (this._quantity.value ? +this._quantity.value : 0) * ((item.costInfo && item.costInfo.cost) ? item.costInfo.cost : 0),
                    isTaxable: data.costInfo?.isTaxable
                });

                // this.sortByDate(this._sortingSelected.value);
                this._selectedStockItem.setValue(null);

                setTimeout(() => {
                    this.kendoComboItems.toggle(true);
                    this.kendoComboItems.focus();
                });
            });
    }

    _onScheduleDateChange(value: Date) {
        this._scheduledDate = value.toLocaleDateString();
    }

    _onSave(e: any) {
        this.submit();
    }

    private _initForm() {
        this._form = this._fb.group({
            accountfromid: [this._model && this._model.accountFrom, Validators.required],
            accounttoid: [this._model && this._model.accountTo, Validators.required],
            sitefromid: [this._model && this._model.siteFrom, Validators.required],
            sitetoid: [this._model && this._model.siteTo, Validators.required],
            scheduledate: [(this._model && this._model.scheduleDate) ? parseDate(this._model.scheduleDate) : null],
            notes: [(this._model && this._model.notes) ? this._model.notes : null],
        });

        if (this._model != null && this._model.accountFrom != null && this._model.accountTo != null && this._model.siteFrom != null && this._model.siteTo != null) {
            this._selectedFromAccounts = this._model.accountFrom;
            this._selectedToAccounts = this._model.accountTo;
            this._selectedFromSites = this._model.siteFrom;
            this._selectedToSites = this._model.siteTo;
        }

        if (this._model != null && this._model.processedOut != null && this._model.processedIn != null && (this._model.processedOut == true || this._model.processedIn == true)) {
            this._isProcessed = true;
        }

        if (this._model != null && this._model.transferRequestDetails != null) {
            this._model.transferRequestDetails.forEach((item: TransferRequestDetail) => {
                this._stockItemsService.getStockItem(item.stockId)
                    
                    .subscribe((data) => {
                        this._stockGridData.push({
                            stockId: item.stockId,
                            stockNumber: data.number,
                            description: data.description,
                            transferQuantity: item.transferQuantity,
                            uom: data.receiveUnitOfMeasure.code,
                            unitCost: (data.costInfo && data.costInfo.cost) ? data.costInfo.cost : 0,
                            extendedCost: (item.transferQuantity) * ((data.costInfo && data.costInfo.cost) ? data.costInfo.cost : 0),
                            isTaxable: (data.costInfo != null && data.costInfo.isTaxable != null) ? data.costInfo.isTaxable : false,
                        });
                    });
            });
        }
    }

    private submit = () => {
        if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            if ((this._selectedFromAccounts.name == this._selectedToAccounts.name) && (this._selectedFromSites.name && this._selectedToSites.name)) {
                this._layoutComponent.openPopup({
                    title: 'Validation',
                    message: 'Transfer Request cannot be performed between the same account and same site.',
                    withoutConfirm: true
                });
                return;
            }
            if (this._stockGridData.length == 0) {
                this._layoutComponent.openPopup({
                    title: 'Validation',
                    message: 'Please add items to the transfer request grid.',
                    withoutConfirm: true
                });
                return;
            }

            this._invalidForm = false;
            const model = this._form.value;
            if (this._model != null && this._model.id != null) {
                model['id'] = this._model.id;
            }
            model.accountfromid = this._selectedFromAccounts.id;
            model.accounttoid = this._selectedToAccounts.id;
            model.sitefromid = this._selectedFromSites.id;
            model.sitetoid = this._selectedToSites.id;
            model.scheduledate = this._scheduledDate;

            model['transferRequestDetails'] = this._stockGridData.map((x) => {
                return {
                    stockId: x.stockId,
                    stockNumber: x.stockNumber,
                    description: x.description,
                    transferQuantity: x.transferQuantity,
                    uom: x.uom,
                    unitCost: x.unitCost,
                    extendedCost: x.extendedCost,
                    isTaxable: x.isTaxable
                };
            });
            if (this._model.id != null) {
                this._transferRequestsService
                    .updateTransferRequest(this._model.id, model)
                    
                    .subscribe((response: any) => {
                        if (response != null && response["message"] != null) {
                            this._layoutComponent.openPopup({
                                title: 'Alert',
                                message: response["message"],
                                withoutConfirm: true
                            });
                            if (response["close"] != null) {
                                if (response["close"] == true) {
                                    this._closeForm();
                                } else {
                                    return;
                                }
                            }
                        }
                        this._closeForm();
                    });
            } else {
                this._transferRequestsService
                    .createTransferRequest(model)
                    
                    .subscribe((response: any) => {
                        if (response != null && response["message"] != null) {
                            this._layoutComponent.openPopup({
                                title: 'Alert',
                                message: response["message"],
                                withoutConfirm: true
                            });
                            if (response["close"] != null) {
                                if (response["close"] == true) {
                                    this._closeForm();
                                } else {
                                    return;
                                }
                            }
                        }
                        this._closeForm();
                    });
            }
        }
    }

    _onEditForm() { }


  scrollCombobox(event:any){
        this.isOpened = true;
        if (this.clearTimeout) clearTimeout(this.clearTimeout);
       this.clearTimeout = setTimeout(() => {
        if (this.isOpened) {
        this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e:any) => {
        if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
         this.beginScroll = true;
          this.comboBoxpagingationParams.currentItem = (parseInt(this.comboBoxpagingationParams.currentItem) + this.comboBoxpagingationParams.totalbyPage).toString();
          //var siteId =  this._form.get('sitefromid').value;
          this._loadTransferItems();
          //this._loadItemsDD(siteId.id);
        }
      });
            }
        }, 2500);
    }

    onBlur(){
      this.beginScroll = false;
      this._items = [];
      this._itemsFiltered = [];
       this.comboBoxpagingationParams.currentItem = "0"
       var siteId =  this._form.get('sitefromid').value;
       this._loadTransferItems();
       //this._loadItemsDD(siteId.id);
    }
    getMarkupType(obj:any, propString:any)
{

  if(obj.costInfo.isCalculatedPrice)
   return "Calclulated Price"
  else if(obj.costInfo.isFixedPrice)
   return "Fixed Price"
}
displayCatImage(input:string,ListOfItems:any=null){
  let primaryPicture;
 if(ListOfItems!=null)
 {
   primaryPicture=ListOfItems.find((v:any) => v.categoryFilePrimary == true);
   if(primaryPicture!=undefined && primaryPicture!=null)
    input=primaryPicture?.file?.thumbnail;
 }
  return EnvironmentLoaderService.envConfig.enterpriseApiLocal+'/'+ input;
}
displayStockImage(input:string,ListOfItems:any=null){
  let primaryPicture;
 if(ListOfItems!=null)
 {
   primaryPicture=ListOfItems.find((v:any) => v.stockitemfileisprimary == true);
   if(primaryPicture!=undefined && primaryPicture!=null)
    input=primaryPicture?.file?.thumbnail;
 }

  return EnvironmentLoaderService.envConfig.enterpriseApiLocal+'/'+ input;
}
getAccountNames(accounts: any[]) : string{
  if (!accounts || !Array.isArray(accounts)) return '';
  const names = accounts
    .map(d => d?.account?.name ?? d?.name)
    .filter((name): name is string => typeof name === 'string' && name.trim().length > 0);
  return Array.from(new Set(names)).join(', ');
}
_closeStockItemNotesWindow(){
  this._showStockItemFileNotes = false;
}
_showStockItemNotesWindow(id:number){
  this._stockItemsService.getStockItem(id)
    
    .subscribe((model: any) => {
      this._stockItemNotesModel = model;
      this._showStockItemFileNotes = true;
    });
}
}
